import { LinkComponentProjectDialogState } from ".";

const displayColumn = [
  { label: "DIP by Region", value: "dipByRgn" },
  { label: "Component ID", value: "cpntId" },
  { label: "Description", value: "cpntReqDesc" },
];

export const LinkComponentProjectDialogInitialState: LinkComponentProjectDialogState =
  {
    isShow: false,
    saved: {},
    edited: {},
    codes: {},
    displayColumn: displayColumn,
    pjtId: "",
    updateDateTime: "",
    status: {
      invalidList: [],
      invalidRecordList: [],
      isSaved: false,
    },
    ifDefinitionResult: {
      total: 0,
      hitCount: 0,
      ifList: [],
    },
    componentProjectResult: {
      cpntPjtList: [],
    },
    refSpreadSheet: {
      tmplateRow: {
        dipByRgn: "",
        cpntId: "",
        cpntReqDesc: "",
        inOutTypeCd: "",
        edhPrtcls: [],
        ediPrtnrs: [],
        edhNotifications: [],
      },
    },
    spreadSheet: {
      tmplateRow: {
        select: false,
        dipByRgn: "",
        cpntId: "",
        cpntPjtTypeName: "",
        inOutTypeName: "",
        prtclTypeName: "",
        cpntPrjName: "",
        cpntPjtId: "",
      },
    },
  };
